import { render, staticRenderFns } from "./card-header-cover.vue?vue&type=template&id=6676016c&scoped=true"
import script from "./card-header-cover.vue?vue&type=script&lang=js"
export * from "./card-header-cover.vue?vue&type=script&lang=js"
import style0 from "./card-header-cover.vue?vue&type=style&index=0&id=6676016c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676016c",
  null
  
)

export default component.exports